import thhwel from "../images/thhwel.png"
export const Bio = {
  name: "Gaurav K Kolhe",
  roles: [
    "Full Stack Developer",
    "Data Analyst",
    "Programmer",
  ],
  description:
    "Enthusiastic and analytical MCA student with a solid foundation in computer science and hands-on experience in data analytics and web technologies. Skilled in Python, Power BI, SQL, and Excel for analyzing and visualizing data, along with knowledge of front-end development using HTML, CSS, JavaScript, and ReactJS. Passionate about transforming data into actionable insights and creating efficient, user-friendly solutions. Committed to continuous learning and contributing effectively to dynamic, technology-driven teams..",
  github: "https://github.com/mrgaurav77",
  resume:
    "https://drive.google.com/file/d/1FpehDbjGALN0PTl55Iuyy5nlHc7TZFre/view?usp=drive_link",
  linkedin: "https://www.linkedin.com/in/gaurav-kolhe-0247a2257/",
  twitter: "https://x.com/gkolhe18",
  insta: "https://www.instagram.com/alkey_gaurav_vii/",
  facebook: "#",
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "Bootstrap",
        image:
          "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      },
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Node Js",
        image: "https://nodejs.org/static/images/logo.svg",
      },
      
      {
        name: "Python",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
      },
      {
        name: "MySQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },
      {
        name: "MongoDB",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
      },
      {
        name: "PHP",
        image: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAADCElEQVR4AWIAgfDYqZr+kQD2qkFLkCAG3geerbVt27Zt27Zt27aZ65rd12/nbNd7o+5MUpNUMr4591747d975Uc/8kAMxEJMHvzOK59tbP7MAzEFEmCDhV9xPHjlm31LnPafnoW9W3zhFx1/LoH/BCSVQ0lKJYweSPj/fAKahjF0fn5BZ+x4pRjy8wmER5cSsLa+8/1LIK8RTio6kfxQ1Ip4J82VNT0EDA7PcJtHUgEim1cKwSI/yux4KR9Md19+hAA2d/cO6SYuL4kODo6ptKKT242Ozb9jc3x8Sp3d4/RUJlCwqWvsp7dxdnZOo+MLpK4f/X4CGqy2l4LDS5qYXKTJqSXa2trjDqLiyun+az/a2T0gYG5+jaaml2l1bVtkA1+T00sErK5u0fjEAi0ubQi6AYZH594hIKrtJgt6cx1BgI6uMVLVjSLg/OKCpFXDsM9I+dP+/hEB8cnVdOeFHx0enhDgHZB3lV12pGbWEXDEsvVIMuAdAqLa3lwfGJzmBCJiyghY39hhgXyF/WeygXTK0gtYO6aSoWUCAcjkSwXeJRQWVXpF4OgDBEbHhdqi3iJdICNATn4zVdVekezrn+I2Dm4ZBJycnNET6UCKTawkYI2V5qb/iupuAhYW15ERMQF8zd61AIPCivhLCSnVV85Pz0hZO5LGmIiAguJWbpOZ20jA/MKaQLiuoZ+A3v5JbqOmH80FnpXb9K4GNAxiCACg8pGxOSagbUHhQHp2g6hLvPzzuBOUBmhpGxaeIV4A76Ocs3OrdMo+AJiaWebp5wS4AMWAalFrCItPQACkJJRCrkvkSysrWwRAZOgStO07rXx4TK3tI/SaT05OQCzA4ZFZ1qdRwiHF5v2dl77c+Il0gLCuohspcqLKnrEOMeqaxnHyBubxWMegQqd8dBLy4VJc1vFNo5ULcJ13yadHMdIGpV+w3vYLLvgmAjV1vcLXd/dOfNm/4Hv9Xl/IB8MPK0fQm422iIjCow4Y8I7JgHfNBrRzGhQ5UwPeQwa5BhQk9Ah2kF2w7jkAoivzGh/q5RMAAAAASUVORK5CYII=",
      },
    ],
  },
  
  {
    title: "Data Analysis",
    skills: [
      {
        name: "Excel",
        image:
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAABUElEQVR4AWP4////gOLB7wDFxWkJQPyfWGx8pJEUnECMA/7T0AH/B78DRh0gNynmPyGsMDeJfAcI1DgmAPF/crBgqvV/qVp/kCMocsB/SjCnu+p/vnwrOJ/EKBtkDpBv8f1/5P4FMK7cNgUubjs1FSYOYtM2BKYfW/MfBD5+/wJyEEgMbDEQgGiaRwHIUrDlINCxb8F/n7mF/2FAryeSPmkga20nLBRAvoY5hq6JEGwxDDx6/4L+uWDrtSMQ2xFxjxXzmcr/Fws2/C8RYw7CpOYirA4AxTssCmDpARQtNHYAIhGCghwW7yCMnCto4ADC2RDuoGXndtDQAYigRw9yMBsKQGqo7wAS8bByAGXVMa+nBrIDyMGEGyTcWpL/cWFeQ9n/grYqtHWAkJP6f0JYPMKUdg4Q9tL5jw+LhRqDDKKdA4gwZPg7IIGGDkgY7R0DAHmp5kQ5gGrkAAAAAElFTkSuQmCC",
      },
      {
        name: "Python",
        image:
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAMAAABF0y+mAAAAh1BMVEVHcEwBVJc3caE2bJdKir3z2mL/6m05daZAfa5Jd5nsyUUqbKFHZ3flw0Towzv+2Uz842rmwTgANYDeuzlFgrL/6nD94WL20ETvxzf50T5Jh7lAfKxAf7E9eqv/5GX/4Fz/6HH/3VNFhbc1cKD/2kowapr/1Dj/10H+/v786a2dt851nL7c5OukoiX2AAAAHHRSTlMAf0dz/ovF/qRkVcoZX2noqUpnMo7r88Ww1sbqk9MnjgAAAR1JREFUKJFl0etygyAQBWCCEIJGozE1TWu9C8b2/Z+vsEscA+ef882RXSBky5nKKJL0TMJINrBhGOr6JwmYMrYCmQhfb8PfstYWhRhlgOvya3vCYBRgPWJPjAHSEwTsDeVpC9h8zfOc41RfjMES7p/jPF8/uq6r4DSwGocBQ2y4Qay5JcAsNk1zMZcW2iwNtW1rr2Yz4eyQg/UlkS9LDi4SrO/7AtGY5EeXCmr9NMWE4qDRscM0rjZNuiQEl0h3BLVJa7PKNxzI/ZrWd4ORHRTwVQNTqrBXlJgdLL79UqlP9yJSUg5WZbFNmmVZsXsZjqddbHTqvSffJmmVynx0p6nn8gwwdZMAFh6SOy6n1DbnW/eB9PDHcSnjotx//wNQ0jN2CWQnkAAAAABJRU5ErkJggg==",
      },
      {
        name: "PowerBI",
        image:
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAADhklEQVR4AWJhoBI4Xc7eD6itDjh3XbAyjP/ut4iGM2nSqFRTIwggBBEE+jLtvkjTEIA+SgCEIODIwDSVpBSVOPtdV2PMy3/Y+2A7B8uzeLAu173W81y9C4IBARUmXPeXf/QXX/w5fGUAl3c1hCkqMwEqMHuHrxagUH79D36RgOKuHo+tgH/6u//FwFcPYO5Z2wZ3VXQkGqb6OgDC1M8SbVOI0PV1GmCsEHdSXkYgvh4DGqi5q83EthV32lrtawKA6DLWDXYX2Ez79Ag+/6vvfC/egUgWSQU+++1f8c0f13/86J/937/+yGMaK0oVtk8yUN4BKUgliM++860fD/8WnV/+jW/7+89/6Fd/6bHLC8JYpXwCgCi/+ce/L1nUeeU96Y6O+OI9zGvomKbgEwBciFKHVKaJOt6aiY4KFBOfClAx6kmpEIUXQJRK8XzWY1ZA+HQDpeiOws9CKMmKounSJoAo2CcagE4dcXdtTSicUKfCw50SUcjyqd+B0h1SRxlefWVekNNl22bC9iUR/OCv//B7be8qW4qhQuCb3/2uX/j273n/Pz/0/r/+wdi9iUQ5UbrwmLhT5fF47KMAp3crgyISUD8Z/tnv/C7e+/lv/Jov/vNzCrnntRlRlMo96/HYsNJd4PoAgNL4rT/5UznD3VXnsQZ6IuBNFGN69SiXsHuqspkofBBAlHpvuHu22ZZ6LVsI1NNdPdZEHaijrI3B4N5rDyvyEQNkTp06Q840wdu8z7QuCiFdyF111rPCHla52AcBHKj3lMdaVZ2w3YhCunN3wWNW5+27scJjW3kZEH08AuppclfbbaO7LIscRS8zqbye8+rH62k268LHAEqiJ3oZQLabUscg3VNpa93bwadS6R4SwdxTnfERgMk8VXhdQuV1CXEhddQqok6iV0356Sk+Vul83EAO3PPZHk0n2VpXxKs6Om/1E6VCKpVtK2peEPmSM9yeW0l0iEJeVcedOl3ttYTQqXSv09vuWWIP68t2gOipN4OqFHsLcuooNOVVOUpN0ft6DX7tQD4IcIC3m3KUrVWvnk73pNzVY0YqxB2XbYPinl4gfHgHIrr3NurA3BQOdIcoFR2oA0o91RT3EwOvX+KX/A1Xkn/8m78FCgEFgDD//S//LowpQQH4tx88+cZgBYhk9gEDz+f3/dz+TBBQDABgoDLAvfpIRFFhBMkwd30f4P8BgCdHZe87LaAAAAAASUVORK5CYII=",
      },
      {
        name: "Tableau",
        image:
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAMAAABF0y+mAAAAQlBMVEVHcExwmaVwmaVlgJtwmaXrkShwmaVah5vrkShah5vodizodizodixbZZFbZZFbZZFbZZHHIDYeRH7HIDYeRH4eRH76/o4UAAAAFXRSTlMAEPw7VXizePb2NP3ws1P8EHh49vNnJOVcAAAAr0lEQVR4AX3Q0RaFEBCF4Q1SCKT3f9WTuaE1R99FN/9iTHgRAmtSYkVpKbUCYwyATT42ANZitu/zyeNgccyco9mJodfCHsSyCIzIrnUOWM70nkdapQsBeK+iNgVgRKJOhU5LzWNMEYCQnYDzIQRPH4ecuvwZv6/9fhApZY61YnZd809o7V90jsVykQJSW7vv1iqLOY/Irk1pOVPFlKLikVY50+Nkq5BxkhkzV3LG7AcvlAr9NZNe3AAAAABJRU5ErkJggg==",
      },
      {
        name: "MySQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },
      {
        name: "Statistics",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/4/40/Fisher_iris_versicolor_sepalwidth.svg/250px-Fisher_iris_versicolor_sepalwidth.svg.png",
      },
    ],
  },
  {
    title: "Others",
    skills: [
      {
        name: "Git",
        image:
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAAA4CAMAAACfWMssAAAAXVBMVEX////wUTPvOwr4tq75x8HwTS3wSSb2o5jvQx3++PfwTzDvRiH+8vDvPxX96+j3s6vvNQD85uT84t7xW0HyaVP1k4bzfWz0j4H2nZH72dT4vrfxZU30iHnxX0fybVjWDntTAAABjUlEQVRIia3W63aDIAwA4EaKpSBI7dr1tr3/Yw5FBBUNcJZ/ot8xmJDj4fD/oVrSlDiihdDHAleBiSpbWpcvncuV3uXJM6NQJhsokU2hJLorkqTirET239NJKQVPlbYOo+zU8UrTpKuflX18JUlfdy6VXbrIhH2G/SLdifrhqAwdiLPL1cMNOXMg3SbRqswd0Pu4rui+XDiT63eSXDmT7MMckw6REQf1yUB92ZUxZ6EUVsa7L+osZNzK5+W17r64GyFYOVR0IZWOOgeNHLtP+e7TfV+1Yh9CNcLDe9qmIH2mKHTdd59yFa25bJBUgT1HyKc36iGJ4+7H8d33Yu5WRexKXE4Q2G14auU2pIdQ08/tJ+LiMoDAac1jLipDGMTcRSSXLwNriri1FMMIOAcjJ+6WciixiU5ibiGnKXflmJvLacr9UtTNpHSHiW7UYUvSj11Z9xkm2Wm4TnShFHB7vJNdKHm91WeYxOuAyTS3lqluKdPdXOa4UOY5L3Odk/nOyP7XusCZSU1ahT+VHX8jrRGDfH3kSQAAAABJRU5ErkJggg==",
      },
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      {
        name: "Netlify",
        image:
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcBAMAAACAI8KnAAAALVBMVEX////f9PQAt7QAu7iM2dj7/v43xMKe3934/f3a8vLGz8+Mn54hwL0ANDI9xcM3IX9gAAAAUUlEQVR4AWOgHDAKoHCZFFC4zAa4uSwBKFynVBS9YeocDUhc1ko0e1fvgrF4jI2NGvbe5lA2Nj6AxkUoRjMKt0VOT5kU0B1J2EcI76MHDsUAANZSEj24Z6GKAAAAAElFTkSuQmCC",
      },
      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },
    ],
  },
];

export const experiences = [
  // {
  //   id: 0,
  //   img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/flipr.jpeg?alt=media&token=1d72532a-45eb-4c1a-a81a-c9bed9fec543",
  //   role: "DevOps & Fullstack Engineering Intern",
  //   company: "Flipr Inovations Pvt. Ltd.",
  //   date: "Aug 2023 - July 2023",
  //   desc: "Working on Flipr Platforms, managing DevOps, and streamlining the process with automation.",
  //   skills: [
  //     "Docker",
  //     "Terraform",
  //     "AWS",
  //     "EC2",
  //     "Portainer",
  //     "Nginx",
  //     "JavaScript",
  //     "TypeScript",
  //     "Node Js",
  //     " Next Js",
  //   ],
  //   doc: "https://media.licdn.com/dms/image/D4D2DAQFlp60ZqHuaFQ/profile-treasury-image-shrink_1280_1280/0/1691180828512?e=1692381600&v=beta&t=mM5Y_NE5EPlQhez5FAN6NLVSKcO_Ojt_9Gq3mnFGkAQ",
  // },
 
];

export const education = [
  {
    id: 0,
    img: "https://metbhujbalknowledgecity.ac.in/wp-content/uploads/2020/03/metnasik.png",
    school: "MET Institute of Management, Nashik",
    // date: "June-2025",
    grade: "Pursuing",
    desc: "Pursuing a Master’s in Computer Applications (MCA), focusing on advanced programming, database management, and data analytics. Actively involved in hands-on projects and assignments to strengthen technical and problem-solving skills. Complementing academic learning with relevant certifications and self-directed skill enhancement. Gaining expertise in software development, web technologies, and emerging computing trends. Preparing to apply knowledge effectively in real-world tech challenges and professional environments.",
    degree: "MCA - Master of Computer Applications",
  },
  {
    id: 0,
    img: "https://bamua.digitaluniversity.ac/user/pages/images/logo_unic.png",
    school: "Deogiri Institute of Engineering and Management Studies, chh.Sambhaji Nagar",
    // date: "June-2025",
    grade: "7.29 CGPA",
    desc: "I have successfully graduated with a B.Sc. in Computer Science, earning a CGPA of 7.29. Throughout my studies, I built a solid foundation in core computer science concepts and practical skills. I actively engaged in projects and hands-on assignments that strengthened my problem-solving abilities. To complement my degree, I completed relevant certifications and continued expanding my knowledge. Graduation has inspired me to keep learning, growing, and applying my skills in real-world opportunities.",
    degree: "B.Sc. in Computer Science",
  },
  {
    id: 1,
    img: "https://www.mahahsscboard.in/boardlogo.svg",
    school: "LDP jr. college, Dahegaon",
    // date: "March 2020",
    grade: "62.2%",
    desc: "I completed my class 12 high school education, where I studied Science with Computer Science.",
    degree: "Maharashtra State Board(XII)",
  },
  {
    id: 2,
    img: "https://www.mahahsscboard.in/boardlogo.svg",
    school: "Shree Pareshwar Mahavidyalaya, Palkhed",
    // date: "Apr 2018",
    grade: "84.2%",
    desc: "I completed my class 10 education, where I studied Science with Computer Application.",
    degree: "Maharashtra State Board (X)",
  },
];

export const projects = [
  {
    id: 0,
    title: "The Helping Hand - Plant Donation Platform",
    date: "Sep 2024 - Jan 2025",
    description:
      "The Helping Hand is a platform designed to prevent healthy plants from being discarded due to space constraints, relocation, or lack of care. It connects plant owners who can no longer maintain their plants with individuals willing to adopt them. Users can list plant details, upload photos, and find nearby adopters easily. The platform is completely free and promotes environmental sustainability by reducing plant waste. Ultimately, it fosters a community of plant lovers and ensures every plant finds a loving home..",
    image:
      {thhwel},
    tags: ["React Js", "MongoDb", "Node Js", "Bootstrap"],
    category: "web app",
    github: "https://github.com/mrgaurav77/The-Helping-Hand",
    webapp: "https://the-helping-hand.netlify.app/",
    member: [
      {
        name: "Gaurav Kolhe",
        img: "https://avatars.githubusercontent.com/u/105879073?v=4",
        linkedin: "https://www.linkedin.com/in/gaurav-kolhe-0247a2257",
        github: "https://github.com/mrgaurav77",
      },
      {
        name: "Yash Sonone",
        img: "https://avatars.githubusercontent.com/u/132239373?v=4",
        linkedin: "https://avatars.githubusercontent.com/u/132239373?v=4", 
        github: "https://github.com/yashsonone99",
      },
    ],
  },
  
];